<template>
    <div>
        <h2>
            Welcome to the Perkins V Postsecondary Portal
        </h2>
        <p>
            This portal is used by colleges and universities and state staff to successfully implement
            and manage Carl D. Perkins CTE Program funds.
        </p>
        <hr>
        <b-row>
            <b-col class="border-right">
                <LoginForm @login="attemptLogin" />
            </b-col>

            <b-col md="5" lg="6">
                <hr class="d-md-none">
                <div class="text-left text-detail">
                    <p class="mb-0">
                        The portal provides for the following program management elements:
                    </p>
                    <ul>
                        <li>Local Application submission and approval process</li>
                        <li>Negotiation of annual core indicator performance targets</li>
                        <li>Revisions to the Local Application when needed</li>
                        <li>Annual Plan submission and approval process</li>
                        <li>Amendments to the Annual Plan following initial approval</li>
                        <li>Activities required to meet Improvement Plan obligations</li>
                        <li>Requests for reimbursements</li>
                        <li>Inventory management</li>
                        <li>
                            End of Year Program Report for activities funded in the previous year
                        </li>
                    </ul>

                    <p>
                        Requests for assistance with the portal should be directed to:
                        <b-link href="mailto:brinda.berry@adhe.edu">
                            Brinda Berry
                        </b-link>
                    </p>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import LoginForm from '@/components/LoginForm';
import { AlertManager } from '$Shared/@arc/vue-arc-alerts';
import { Log } from '$Shared/@arc/vue-arc';
import { mapActions } from 'vuex';

export default {
    name: 'Home',
    layout: 'GuestLayout',

    components: {
        LoginForm
    },

    methods: {
        ...mapActions({
            login: 'auth/login',
        }),

        async attemptLogin(credentials) {
            try {
                await this.login(credentials);
                this.$router.push({ name: process.env.VUE_APP_USER_HOME_ROUTE });
            } catch (arcAlert) {
                Log.error(arcAlert, 'COMPONENT->Login Error caught: ');
                AlertManager.showErr(arcAlert);
            }
        },
    }
};
</script>

<style>
    .text-detail {
        font-size: 0.85rem;
    }

    .text-detail ul {
        font-size: 0.8rem;
    }
</style>
